var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex items-center py-5",class:{
    'text-gray-500': !_vm.savedReply.published,
    'text-gray-900': _vm.savedReply.published,
  },attrs:{"to":{ name: 'editSavedReply', params: { savedReplyId: _vm.savedReply.id } },"tag":"div"}},[_c('h3',{staticClass:"mb-0",class:{
      italic: !_vm.savedReply.published,
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.savedReply.isImage)?_c('font-awesome-icon',{staticClass:"mx-3",attrs:{"icon":['far', 'image-polaroid'],"fixed-width":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }